
import { defineComponent } from 'vue';
import AdDeveloperProjectListItem from '@/ad/components/AdDeveloperProjectListItem.vue';
import { adService } from '../AdService';
import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import { scrollToAnchor } from '@/shared/helpers/scrollToAnchor';
import Multiselect from 'vue-multiselect';

export default defineComponent({
  components: {
    AdDeveloperProjectListItem,
    Multiselect,
  },
  props: {
    isPublic: Boolean,
    moreAdsTitle: Boolean,
    currentAdId: Number,
    parentAdId: {
      type: Number,
      required: true,
    },
    parentAdFrontId: String,
    parentAdTitle: String,
    maxFloor: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      estateSubTypes: [],
      allEstateSubTypes: [],
      statuses: [],
      floors: [],
      pagedList: {
        data: [],
        page: 1,
        pageSize: 20,
        currentCount: 0,
        totalCount: 0,
      },
      queryParams: {
        page: 1,
        pageSize: 9999,
        sortBy: 'title',
        estateFrontSubType: null as null | undefined | number,
        floor: null as null | number,
        status: null as null | number,
        priceFrom: null as null | number,
        priceTo: null as null | number,
      },
      sortBy: {},
      sortByTypes: [],
    };
  },
  watch: {
    sortBy: {
      handler: function (val) {
        this.queryParams.sortBy = val.value;
      },
    },
    status: {
      handler: function () {
        this.search();
      },
    },
    queryParams: {
      handler: function () {
        this.search();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
  },
  async created() {
    try {
      this.sortByTypes = [
        { value: 'title', title: this.$t('AdDeveloperProjectList.sort-types.title'), icon: 'icon-sort-asc' },
        { value: 'title desc', title: this.$t('AdDeveloperProjectList.sort-types.title-desc'), icon: 'icon-sort-desc' },
        { value: 'price', title: this.$t('AdDeveloperProjectList.sort-types.price'), icon: 'icon-sort-desc' },
        { value: 'price desc', title: this.$t('AdDeveloperProjectList.sort-types.price-desc'), icon: 'icon-sort-asc' },
      ];
      this.sortBy = this.sortByTypes[0];

      for (let i = 1; i <= this.maxFloor; i++) {
        this.floors.push({
          key: i,
          value: i + '/' + this.maxFloor,
        });
      }

      const result = await adService.getFilter();
      this.estateSubTypes = result.data.estateTypes.find((x) => x.key === 100).estateSubTypes;
      this.allEstateSubTypes = [...this.estateSubTypes];
      this.statuses = result.data.developerProjectStatuses;
    } catch (error) {
      console.error(error);
    }
    await this.search(true);

    scrollToAnchor(this.$route.hash);
  },
  methods: {
    async search(initial = false) {
      try {
        this.isLoading = true;

        const params = Object.assign({}, this.queryParams);

        params.parentAdId = this.parentAdId;

        if (this.isPublic) {
          this.pagedList = (await adService.getDeveloperProjectItems(params)).data;
        } else {
          this.pagedList = (await adService.getMyDeveloperProjectItems(params)).data;
        }
        if (initial) {
          this.estateSubTypes = this.allEstateSubTypes.filter((x) => this.pagedList.data.some((y) => y.estateFrontSubType === x.key));
        }
      } catch (error) {
        //this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onPublishChange(ad: any) {
      try {
        this.isLoading = true;
        if (!ad.isPublished) {
          await adService.publish(ad.adId);
          ad.publishDate = new Date();
          ad.lastChangedDate = new Date();
        } else {
          await adService.unpublish(ad.adId);
          ad.lastChangedDate = new Date();
        }
        ad.isPublished = !ad.isPublished;
      } catch (error) {
        console.error(error);
        //this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
